"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusKeys = void 0;
const lodash_1 = __importDefault(require("lodash"));
function getTableStatusKey(order) {
    var _a;
    // 使用項目轉枱後第一張batch不一定有items
    const isOrdered = (_a = order.batches) === null || _a === void 0 ? void 0 : _a.some(o => { var _a; return ((_a = o === null || o === void 0 ? void 0 : o.items) === null || _a === void 0 ? void 0 : _a.length) > 0; });
    if (order.status === 'cancelled') {
        return order.payments.length > 0 ? 'delete_order' : 'cancel_table';
    }
    // 第三方支付付款中（還沒有 payments 有第三方支付 gateway）
    if (order.status === 'pending' && lodash_1.default.some(order.payments, ['status', 'pending']) && order.gateway !== '' && order.from !== 'MERCHANT') {
        return 'paying';
    }
    // 在店家付款中（已付了1次以上但尚未付完）
    if (order.status === 'pending' && order.payments.length > 0) {
        return 'waiting_pay';
    }
    if (order.status === 'pending') {
        return isOrdered ? 'waiting_pay' : 'waiting_order';
    }
    if (order.status === 'paid') {
        const isWaitingPickUp = typeof order.pickupNotifyAt === 'string';
        return isWaitingPickUp ? 'waiting_pick_up' : 'paid';
    }
    return 'unknown';
}
function getTakeawayStatusKey(order) {
    var _a, _b;
    const isOrdered = ((_b = (_a = order.batches[0]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0;
    if (order.status === 'cancelled') {
        return order.payments.length > 0 ? 'delete_order' : 'cancel_order';
    }
    // 付款中
    if (order.status === 'pending' && lodash_1.default.some(order.payments, ['status', 'pending']) && order.gateway !== '') {
        return 'paying';
    }
    // 先處理通用的 takeawayStatus
    if (order.takeawayStatus === 'confirmed') {
        // 餐廳已確認，顯示「備餐中」
        return 'preparing_meal';
    }
    if (order.takeawayStatus === 'ready' && order.status === 'paid') {
        // 餐點已完成，顯示「待取餐」
        return 'waiting_pick_up';
    }
    if (order.takeawayStatus === 'completed') {
        // 客人已取餐，顯示「已取餐」
        return 'picked_up';
    }
    // 處理 status pending
    if (order.status === 'pending') {
        if (!isOrdered) {
            // batch 中沒東西，直接顯示「未點餐」
            return 'waiting_order';
        }
        return 'waiting_pay';
    }
    // 處理 status paid
    if (order.status === 'paid') {
        if (order.takeawayStatus === 'pending') {
            // 餐廳還沒確認，顯示「待接單」
            return 'waiting_accept';
        }
    }
    return 'unknown';
}
function getDeliveryStatusKey(order) {
    const isMerchentDelivery = false; // TODO: 如何判斷是店家自己送(貨到付款)
    if (order.status === 'cancelled' || order.takeawayStatus === 'cancelled') {
        return order.payments.length > 0 ? 'delete_order' : 'cancel_order';
    }
    // 第三方支付付款中
    if (order.status === 'pending' && lodash_1.default.some(order.payments, ['status', 'pending']) && order.gateway !== '') {
        return 'paying';
    }
    if (order.takeawayStatus === 'pending') {
        // 餐廳還沒確認，顯示「待接單」
        // 店家 key 的單會自動 call confirm api
        // 所以這個 takeawayStatus pending 只會在很短暫的時間出現，之後就會直接變成 confirmed
        // 客人下的單才會等店家接單
        return 'waiting_accept';
    }
    if (order.takeawayStatus === 'confirmed') {
        // 餐廳已確認，顯示「備餐中」
        return 'preparing_meal';
    }
    if (order.takeawayStatus === 'ready') {
        // 餐點已完成，顯示「待取餐」
        return 'waiting_pick_up';
    }
    if (order.takeawayStatus === 'completed') {
        // client 下單，已結帳的訂單顯示「配送中」，否則顯示「待結帳」等外送員帶現金錢回來結帳
        return order.status === 'paid' ? 'in_delivery' : 'waiting_pay';
    }
    if (order.takeawayStatus === 'delivered') {
        // client 下單，由串接的外送 webhook 更改為 delivered，顯示「已送達」，若是店家自己送(貨到付款)則顯示「已完成」
        return isMerchentDelivery ? 'complete' : 'arrived';
    }
    return 'unknown';
}
exports.getStatusKeys = {
    table: getTableStatusKey,
    takeaway: getTakeawayStatusKey,
    delivery: getDeliveryStatusKey,
    storeDelivery: getDeliveryStatusKey,
    shop: getDeliveryStatusKey,
};
// 排序資料並將可以辨識是否唯一的資料加入 dataId
function getDisplayStatusKey(order) {
    if (order.deliveryType == null)
        return 'unknown';
    const stautsConfig = exports.getStatusKeys[order.deliveryType];
    return stautsConfig(order);
}
exports.default = getDisplayStatusKey;
//# sourceMappingURL=getDisplayStatusKey.js.map